export const types = {
    SET_LIST_CURRENCY: '[CODE COUNTRY] SET LIST CURRENCY'
}